class ListToggle {
    constructor() {
        document.querySelectorAll('.pcsl-map-list-toggle-option').forEach(toggle => {
            toggle.addEventListener('click', (e) => {
                document.querySelectorAll('.pcsl-map-list-toggle-option').forEach(t => t.classList.remove('active'));
                e.currentTarget.classList.add('active');
            });
        });
    }
}
